import { render, staticRenderFns } from "./WidgetAdd.vue?vue&type=template&id=720d4550&scoped=true&"
import script from "./WidgetAdd.vue?vue&type=script&lang=js&"
export * from "./WidgetAdd.vue?vue&type=script&lang=js&"
import style0 from "./WidgetAdd.vue?vue&type=style&index=0&id=720d4550&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720d4550",
  null
  
)

export default component.exports